import React from 'react';
import { extractAmountFromImage } from './iaGetAmount';
import VoucherLinkingModal from './voucherLinkingModal';
import $ from "jquery";

class VoucherUploadModal extends React.Component {
    state = {
        files: [],
        uploading: false,
        vouchers: [],
        deliveries: [],
        showLinkingModal: false
    };

    handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files || []);
        this.setState(prev => ({
            files: [...prev.files, ...selectedFiles]
        }));
    };

    removeFile = (index) => {
        this.setState(prev => ({
            files: prev.files.filter((_, i) => i !== index)
        }));
    };

    handleUpload = async () => {
        const { files } = this.state;
        if (!files.length) return;

        this.setState({ uploading: true });

        try {
            const vouchers = [];

            for (const file of files) {
                let amount = 0;

                if (file.type.startsWith('image/')) {
                    const detected = await extractAmountFromImage(file);
                    if (detected) amount = detected;
                }

                vouchers.push({
                    voucher_number: `VOUCH-${Date.now()}-${Math.floor(Math.random() * 1000)}`,
                    file_url: null,
                    amount,
                    date: new Date().toISOString().split('T')[0],
                    delivery_ids: [],
                    notes: file.name
                });
            }


            this.setState({
                vouchers,
                files: [],
                showLinkingModal: true
            });

            $('#voucherUploadModal').modal('hide');
            $('#voucherLinkingModal').modal('show');


        } catch (err) {
            console.error(err);
        } finally {
            this.setState({ uploading: false });
        }
    };

    render() {
        const { files, uploading, vouchers, deliveries, showLinkingModal } = this.state;

        return (
            <>
                {/* MODAL UPLOAD */}
                <div
                    className="modal fade"
                    id="voucherUploadModal"
                    tabIndex="-1"
                    role="dialog"
                    data-backdrop="static"
                >
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content" style={{ borderRadius: 14 }}>

                            {/* HEADER */}
                            <div className="modal-header">
                                <h5 className="modal-title font-weight-bold">
                                    Cargar comprobantes de pago
                                </h5>
                                <button type="button" className="close" data-dismiss="modal">
                                    <span>&times;</span>
                                </button>
                            </div>

                            {/* BODY */}
                            <div className="modal-body">
                                <div
                                    className="border rounded text-center p-4 mb-4"
                                    style={{
                                        borderStyle: 'dashed',
                                        borderWidth: 2,
                                        cursor: uploading ? 'not-allowed' : 'pointer'
                                    }}
                                    onClick={() =>
                                        !uploading &&
                                        document.getElementById('voucherUploadInput').click()
                                    }
                                >
                                    <input
                                        id="voucherUploadInput"
                                        type="file"
                                        className="d-none"
                                        multiple
                                        accept="image/*,.pdf"
                                        onChange={this.handleFileChange}
                                        disabled={uploading}
                                    />

                                    <i className="far fa-file-alt fa-3x mb-3 text-warning" />
                                    <div className="font-weight-bold">
                                        Haz click para seleccionar archivos
                                    </div>
                                    <small className="text-muted">
                                        PDF, JPG, PNG — selección múltiple
                                    </small>
                                </div>

                                {files.length > 0 && (
                                    <>
                                        <label className="font-weight-bold mb-2">
                                            Archivos seleccionados ({files.length})
                                        </label>

                                        <div style={{ maxHeight: 200, overflowY: 'auto' }}>
                                            {files.map((file, index) => (
                                                <div
                                                    key={index}
                                                    className="d-flex justify-content-between align-items-center border rounded p-2 mb-2"
                                                >
                                                    <div className="d-flex align-items-center">
                                                        <i className="far fa-file mr-2 text-muted" />
                                                        <div>
                                                            <div style={{ fontSize: 14 }}>{file.name}</div>
                                                            <small className="text-muted">
                                                                {(file.size / 1024).toFixed(2)} KB
                                                            </small>
                                                        </div>
                                                    </div>

                                                    <button
                                                        className="btn btn-sm btn-link text-danger"
                                                        onClick={() => this.removeFile(index)}
                                                        disabled={uploading}
                                                    >
                                                        <i className="fas fa-times" />
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                )}
                            </div>

                            {/* FOOTER */}
                            <div className="modal-footer">
                                <button
                                    className="btn secondary-action"
                                    data-dismiss="modal"
                                    disabled={uploading}
                                >
                                    Cancelar
                                </button>

                                <button
                                    className="btn botonCorrect text-white d-flex align-items-center"
                                    onClick={this.handleUpload}
                                    disabled={!files.length || uploading}
                                >
                                    {uploading ? (
                                        <>
                                            <i className="fas fa-spinner fa-spin mr-2" />
                                            Cargando...
                                        </>
                                    ) : (
                                        <>
                                            <i className="far fa-file-invoice mr-2" />
                                            Cargar
                                        </>
                                    )}
                                </button>
                            </div>

                        </div>
                    </div>
                </div>

                {/* MODAL LINKING */}
                {showLinkingModal && (
                    <VoucherLinkingModal
                        vouchers={vouchers}
                        deliveries={deliveries}
                        onSave={this.saveVouchers}
                    />
                )}
            </>
        );
    }
}

export default VoucherUploadModal;
